import React from 'react';
import { motion } from 'framer-motion';
import { Slide, SlideHeader, itemVariants } from '../Slide';
export function SlideProblem() {
  return <Slide data-id="element-163">
      <SlideHeader data-id="element-164">The Problem</SlideHeader>

      <div className="flex-1 flex flex-col justify-center max-w-6xl" data-id="element-165">
        <motion.h2 variants={itemVariants} className="text-5xl md:text-7xl lg:text-[100px] font-serif leading-[1.05] tracking-tight mb-16" data-id="element-166">
          Engineering orgs spend{' '}
          <span className="italic text-gray-400" data-id="element-167">millions</span> on AI agents.
          <br data-id="element-168" />
          Nobody can prove they work.
        </motion.h2>

        <motion.div variants={itemVariants} className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-16 pt-12 border-t border-gray-800" data-id="element-169">
          <div data-id="element-170">
            <div className="text-4xl md:text-5xl font-serif mb-2" data-id="element-171">40%</div>
            <div className="text-sm text-gray-400 uppercase tracking-wider leading-relaxed" data-id="element-172">
              Of Copilot & Cursor seats remain unused after 30 days
            </div>
          </div>
          <div data-id="element-173">
            <div className="text-4xl md:text-5xl font-serif mb-2" data-id="element-174">$1.2M</div>
            <div className="text-sm text-gray-400 uppercase tracking-wider leading-relaxed" data-id="element-175">
              Average enterprise spend on AI dev tools with zero ROI tracking
            </div>
          </div>
          <div data-id="element-176">
            <div className="text-4xl md:text-5xl font-serif mb-2" data-id="element-177">0</div>
            <div className="text-sm text-gray-400 uppercase tracking-wider leading-relaxed" data-id="element-178">
              Systems of record connecting AI activity to business outcomes
            </div>
          </div>
        </motion.div>
      </div>
    </Slide>;
}